import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/common/header/header.component';
import { LegancyComponent } from './components/legancy/legancy.component';
import { AdmissionsComponent } from './components/admissions/admissions.component';
import { FranchiseOpportunityComponent } from './components/franchise-opportunity/franchise-opportunity.component';
import { BlogComponent } from './components/blog/blog/blog.component';
import { PentemindComponent } from './components/pentemind/pentemind.component';
import { PlayGroupComponent } from './components/play-group/play-group.component';
import { NurseryComponent } from './components/nursery/nursery.component';
import { KindergartenComponent } from './components/kindergarten/kindergarten.component';
import { TeacherTrainingComponent } from './components/teacher-training/teacher-training.component';
import { DayCareComponent } from './components/day-care/day-care.component';
import { OurApproachComponent } from './components/our-approach/our-approach.component';
import { VisionComponent } from './components/vision/vision.component';
import { AwardsAndRecognitionComponent } from './components/awards-and-recognition/awards-and-recognition.component';
import { LocateUsComponent } from './components/locate-us/locate-us.component';
import { OurPresenceComponent } from './components/our-presence/our-presence.component';
import { PartnerLandingComponent } from './components/partner-landing/partner-landing.component';
import { AdmissionThankyouComponent } from './components/thank-you/admission-thankyou/admission-thankyou.component';
import { FranchiseThankyouComponent } from './components/thank-you/franchise-thankyou/franchise-thankyou.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { BlogDetailsComponent } from './components/blog/blog-details/blog-details.component';
import { InnewsComponent } from './components/innews/innews.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { PreschoolInCityComponent } from './components/preschool-in-city/preschool-in-city.component';
import { KesComponent } from './components/kes/kes.component';
import { KesThankyouComponent } from './components/thank-you/kes-thankyou/kes-thankyou.component';
import { AdmissionEnquiryComponent } from './components/admission-enquiry/admission-enquiry/admission-enquiry.component';
import { AdmissionEnquiryThankyouComponent } from './components/admission-enquiry/admission-enquiry-thankyou/admission-enquiry-thankyou.component';
import { KidzeePartnerComponent } from './kidzee-partner/kidzee-partner.component';
import { KidzeePartnerThankyouComponent } from './kidzee-partner-thankyou/kidzee-partner-thankyou.component';

import { cityPartnerGuard } from './city-partner.guard';
const routes: Routes = [
  // { path: '', component: HomeComponent },
  // { path: 'page-not-found', component: PagenotfoundComponent },
  // { path: 'admission/thankyou', component: AdmissionThankyouComponent },
  // { path: 'franchise/thankyou', component: FranchiseThankyouComponent },
  // alredy commented blog
  // { path: 'blog/:name', component: BlogComponent }, alredy commented
  // { path: 'blog', component: BlogDetailsComponent },
  // end alredy commented blog

  // { path: 'elementary-school/thankyou', component: KesThankyouComponent },

  { path: '', component: AdmissionEnquiryComponent },
  { path: 'admission-enquiry', component: AdmissionEnquiryComponent },
  { path: 'admission-enquiry/thankyou', component: AdmissionEnquiryThankyouComponent },
  // kdzee partner code
  // { path: '', component: KidzeePartnerComponent },
  // { path: 'kidzee-partner', component: KidzeePartnerComponent },
  // { path: 'kidzee-partner/thankyou', component: KidzeePartnerThankyouComponent },
  // {
  //   path: '',
  //   component: HeaderComponent,
  //   children: [
  //     { path: 'pentemind', component: PentemindComponent },
  //     { path: 'error', component: PagenotfoundComponent },
  //     { path: 'innews', component: InnewsComponent },
  //     { path: 'blog', component: BlogComponent },
  //     { path: 'blog/:name', component: BlogComponent },
  //     { path: 'legacy', component: LegancyComponent },
  //     { path: 'admissions', component: AdmissionsComponent },
  //     { path: 'partner-with-kidzee', component: FranchiseOpportunityComponent },
  //     { path: 'playgroup', component: PlayGroupComponent },
  //     { path: 'nursery', component: NurseryComponent },
  //     { path: 'kindergarten', component: KindergartenComponent },
  //     {
  //       path: 'teacher-training-programme',
  //       component: TeacherTrainingComponent,
  //     },
  //     { path: 'daycare', component: DayCareComponent },
  //     { path: 'kidzee-advantage', component: OurApproachComponent },
  //     { path: 'vision-and-mission', component: VisionComponent },
  //     {
  //       path: 'awards-and-recognition',
  //       component: AwardsAndRecognitionComponent,
  //     },
  //     { path: 'locateus', component: LocateUsComponent },
  //     { path: 'our-presence', component: OurPresenceComponent },
  //     { path: 'elementary-school', component: KesComponent },
  //     { path: 'privacy-policy', component: PrivacyPolicyComponent },
  //     { path: ':city/:partnerLanding', component: PartnerLandingComponent },
  //     { path: ':city', component: PreschoolInCityComponent },

  //   ],
  // },
  // { path: 'page-not-found', component: PagenotfoundComponent },
  { path: '**', component: PagenotfoundComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
